module.exports = __webpack_public_path__ + "fonts/bariol-bold.735d8a60.ttf";